export const featuresAppRoot = "/features";
export const featuresDashboard = "/features/f";

export const isSmallWindow = window.innerWidth < 600;